import { useContext, useState } from "react";
import { getTranslate } from "react-localize-redux";
import { useSelector } from "react-redux";

import { MainContext } from "@context";

const selectTranslate = (state) => ({
	translate: getTranslate(state.localize),
});

const useController = () => {
	const { translate } = useSelector(selectTranslate);

	const [isHovered, setIsHovered] = useState(false);
	const {
		state: { isMobile },
	} = useContext(MainContext);

	const handleMouseEnter = () => {
		setIsHovered(true);
	};

	const handleMouseLeave = () => {
		setIsHovered(false);
	};

	return {
		helpers: { translate },
		state: { isHovered, isMobile },
		handlers: { handleMouseEnter, handleMouseLeave },
	};
};

export default useController;
